// extracted by mini-css-extract-plugin
export default {"container":"WebcamCapture_container__IMdbZ","webcam":"WebcamCapture_webcam__DJ+C9"};